import React from 'react'
import {useProfessorsQuery} from '../utils/hooks/useProfessorsQuery'
import {Typography} from './Typography'

const AuthorCard = ({authorName}) => {
  const professors = useProfessorsQuery()

  const author = professors.find(professor => {
    return professor.name.toLowerCase() === authorName.toLowerCase()
  })

  return (
    <div className="relative my-16">
      <div
        className="absolute w-36 h-36 z-0 rounded-full bg-no-repeat bg-center bg-cover transform top-0 lg:left-0 inset-x-1/2 lg:inset-y-1/2 -translate-x-1/2 lg:translate-x-0 lg:-translate-y-1/2"
        style={{
          backgroundImage: `url(${author?.photo})`,
        }}
      ></div>
      <div className="grid grid-cols-4 lg:grid-cols-8 gap-4">
        <div className="mt-16 lg:mt-0 rounded shadow-1 col-start-1 lg:col-start-2 col-end-5 lg:col-end-9">
          <div className="px-4 py-8 pt-24 lg:pt-4 lg:grid lg:grid-cols-7 lg:gap-4">
            <Typography
              size="lg"
              weight="black"
              className="col-start-2 col-end-8 mb-4"
            >
              {author?.name}
            </Typography>
            <Typography className="overflow-hidden truncate-4 col-start-2 col-end-8">
              {author?.description}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

export {AuthorCard}
